export default __webpack_public_path__ + "static/media/STRIPAnimatedGif-inside.87c313bf.gif";